import { apiClient } from '../api/client';

export interface OrderItem {
  id?: string;
  productId: string | null;
  type?: 'PRODUCT' | 'CREDIT' | 'VIP_UPGRADE';
  productName: string;
  categoryName?: string | null;
  price: number;
  quantity: number;
  total: number;
  customAmount?: number | null;
}

export interface OrderDelivery {
  id: string;
  serverName: string | null;
  command: string;
  status: string;
  deliveredAt: string | null;
}

export interface PlayerOrder {
  id: string;
  status: string;
  paymentMethod?: string;
  total: number;
  subtotal: number;
  discountAmount: number;
  createdAt: string;
  items: OrderItem[];
}

export interface PlayerOrderDetail extends PlayerOrder {
  paymentId: string | null;
  couponCode: string | null;
  creditUsed: number;
  deliveries: OrderDelivery[];
}

export interface ListPlayerOrdersResponse {
  orders: PlayerOrder[];
}

export interface GetPlayerOrderDetailResponse {
  order: PlayerOrderDetail;
}

class OrderService {
  async listPlayerOrders(storeId: string): Promise<PlayerOrder[]> {
    try {
      const response = await apiClient.get<ListPlayerOrdersResponse>(
        `/public/stores/${storeId}/orders`
      );
      return response.orders;
    } catch {
      return [];
    }
  }

  async getOrderById(storeId: string, orderId: string): Promise<PlayerOrderDetail | null> {
    try {
      const response = await apiClient.get<GetPlayerOrderDetailResponse>(
        `/public/stores/${storeId}/orders/${orderId}`
      );
      return response.order;
    } catch {
      return null;
    }
  }
}

export const orderService = new OrderService();
